module.exports = __webpack_public_path__ + "static/media/arrow-circle-left-solid.edd19bb1.svg";